import { z } from 'zod';
import { pageSchema } from '../common/pagination';

export const createNoteRequestSchema = z.object({
  text: z.string().min(1).max(500),
});
export type CreateNoteRequest = z.infer<typeof createNoteRequestSchema>;

export const noteSchema = z.object({
  id: z.guid(),
  text: z.string(),
  createdAt: z.string().datetime(),
});
export type Note = z.infer<typeof noteSchema>;

export const notePageSchema = pageSchema(noteSchema);
export type NotePage = z.infer<typeof notePageSchema>;

export const noteStatsSchema = z.object({
  notesCreated: z.number().int(),
});
export type NoteStats = z.infer<typeof noteStatsSchema>;
